angular.module('account').controller('ChangePasswordCtrl',
    ['$scope', 'toaster', 'aprgettext', 'TransitionManager', 'SessionService', 'AccountRepository', 'LocalStorageRepository',
        function ($scope, toaster, gettext, TransitionManager, SessionService, AccountRepository, LocalStorageRepository) {
            'use strict';

            $scope.loading = false;
            $scope.model = {
                Id: LocalStorageRepository.getUserID(),
                OldPassword: '',
                NewPassword: ''
            };
            $scope.confirmNewPassword = '';

            $scope.back = back;

            $scope.submit = submit;

            function back() {
                SessionService.setDisplayDashboardToolbar(false);
                TransitionManager.transition({appRoute: 'login'});
            }

            function submit() {

                if ($scope.changePasswordForm.$invalid) {
                    return;
                }

                $scope.loading = true;

                AccountRepository.postChangePassword($scope.model)
                    .then(function () {
                        toaster.pop('success', '', gettext('Password has been changed successfully. Please login with new password.'));
                        TransitionManager.transition({appRoute: 'login'});
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('One or more answers were incorrect. Please try again or contact your practice for further assistance.'));
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }
        }]);